import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/ducks';
import { useEventsBanner } from 'hooks/useEventsBanner';

import { ImgBanner } from './styles';
import { IBannerProps } from './interface';

export const Banner: React.FC<IBannerProps> = ({className}: IBannerProps) => {

    const dispatch = useDispatch();
    const banner = useSelector((state: RootState) => state.eventsBanner);

    const isBannerActive = !!banner?.url_banner_dashboard;

    useEventsBanner(dispatch, isBannerActive);

    if (!isBannerActive) return null;

    return (
        <ImgBanner
            className={className}
            src={banner.url_banner_dashboard}
            alt=""
        />
    );
}